import React from 'react';
import {Image} from 'react-bootstrap';

import './Play.css';

const play = props => (
  <div className="column-big-container">

      <div className="play-image">
        <Image src="images/Teater/bioteater_3bilder.jpg" responsive/>
      </div>

      <div className="play-info">
        <h3>Spela teater</h3>

        <div className="compact">
          <h4>Teatergrupper</h4>
          <p>Förlagshuset Wasa/ILKA är också ett teaterförlag och har teatermanus
            till ”Vännerna i Kungaskogen bygger en koja”. Om externa teatergrupper
            och musikalgrupper vill spela ”Vännerna i Kungaskogen” vänligen
            kontakta förlaget 040-12 00 12 eller idea@ilka.se</p>

          <h4>Egen elevföreställning på skola/förskola</h4>
          <p>I access Kungaskogen finns färdiga teaterförslag och manus på
            föreställningar som en förskola/skola kan spela och genomföra
            för t.ex. andra elever eller föräldrar.</p>

          <h4>Mer än 30 år som nöjes- och kulturarrangör för barn</h4>
          <p>1987 startade ILKA sitt engagemang för barnkultur och
            barnunderhållning. Vi insåg att barn behövde komma från förskolan
            och få upplevelser och att barn var för mycket på ”dagis” (som det
            hette på den tiden).</p>

          <h4>Dundersuccé i Malmö</h4>
          <p>Vi började samarbeta med Mora Träsk som kom till Malmö och Amiralen.
            Av någon anledning kunde inte Mora Träsk få engagemang i Malmö. Det
            blev en dundersuccé för det nya samarbetet ILKA – Mora Träsk.
            Tusentals ”dagisbarn” från Malmö kom till Amiralen för att dansa och
            sjunga med Mora Träsk. Under följande år åkte ILKA som arrangör
            land och rike runt med de numera klassiska barnsångerna som Mora
            Träsk har skapat. Samarbetet består än idag då ILKA som förlag
            producerat ”Mora Träsk sånglekbok” som är en av de finaste utgivna
            sångböckerna på 2000-talet. Över 10 000 ex är sålda av sångboken. </p>

          <h4>Nya produktioner</h4>
          <p>ILKA fortsatte med barnunderhållning på 90-talet och nu med Ulf
            Löfgrens Luddefigur kring vilken vi skapade en egen barnföreställning
            med sång och musik. Över 30 000 barn såg denna produktion och det
            blev även en norsk uppsättning som gick för fulla hus i Oslo.
            ILKA var producent och idégivare.</p>

          <h4>Ny lag ändrade förutsättningar för barnföreställningar på förskola</h4>
          <p>När så lagen om förbud att be om lite pengar från föräldrar kom i
            mitten på 90-talet så stoppade vi våra produktioner då
            bidragsfinansierad barnkultur tog över.</p>
          <p>Men ILKA och dotterbolaget Wasa Music kunde inte låta bli att vara
            med i den viktiga delen av barns liv – möte med teater i kontrast
            till data, TV och video.</p>

          <h4>Nya teatern ”Vännerna i Kungaskogen” gör succé</h4>
          <p>Sagobokssuccén ”Vännerna i Kungaskogen” blev barnteater med det
            viktiga budskapet ”att vara schysst och en bra kompis”. ILKA/Wasa
            Music med Wasa Barnteater hade världspremiär på teatern ”Vännerna
            i Kungaskogen” i Göteborg 2008 mitt under brinnande finanskris.
            Sen har teatern levt vidare och spelats på scener i Sverige och
            ett flertal gånger på Palladium i Malmö. I mars 2013 spelades
            barnteatern ”Vännerna i Kungaskogen bygger en koja” på nytt på
            Palladium i Malmö där alla föreställningar snabbt blev utsålda.
            Föreställningarna filmades av och vi klippte ihop filmmaterialet
            för att kunna visa på bioduk. Så skapades en ny succé, Bioteatern
            Vännerna i Kungaskogen – förmodligen Sveriges första digitala
            barnteater. Över 100 000 barn sett föreställningen från Trelleborg i söder till Boden i norr och teatern har visats på över 60 platser i Sverige.
Plöstligt kom pandemin 2020 och 2021 och satte stop för all publika sammankomster. Teatern lades om ett nytt medium, streaming och kunder fortsätta att visas hela tiden men nu på förskola och begränsade sammankomster, Mottagandet är fantastiskt och teatern fortsätter nu som streamad föreställning. Visas hela året tisdagar, onsdagar och torsdagar. Turnén med Streamad teater fortsätter. Nu har över 150 000 barns sett teaterföreställningen ”Vännerna i Kungaskogen”</p>

          <h4>Teater med tema vänskap</h4>
          <p>Teatern ”Vännerna i Kungaskogen” har ett aktuellt tema: att lära
            barn ”att vara schysst och en bra kompis”. Med humor och musik,
            dans och sång får barn vara med i sagan om hur 2 bästisar blir 6
            kompisar och upptäcker att det är roligt att vara vänner, samarbeta,
            visa respekt för varandra samtidigt som de bygger en trädkoja
            i Kungaskogen. Förlagshuset Wasa med ILKA och Wasa Music äger
            alla rättigheter till manus och musik till ”Vännerna i Kungaskogen”.
            Vi hoppas under kommande år att andra arrangörer ska upptäcka
            barnteatern ”Vännerna i Kungaskogen” och dess möjligheter.</p>

          <h4>Bioteater Vännerna i Kungaskogen</h4>
          <p>Trailer och info om förskolebion ”Bioteater Vännerna i Kungaskogen”
            Klicka på länken! Bioteater Kungaskogen.</p>

        </div>



    </div>
  </div>
);

export default play;
